export { default as WoundOrderService } from "./WoundOrderService";
export { default as WoundOrderRouteService } from "./WoundOrderRouteService";
export { default as WoundService } from "./WoundService";
export { default as WoundRouteService } from "./WoundRouteService";
export { default as WoundDressingService } from "./WoundDressingService";
export { default as WoundDressingRouteService } from "./WoundDressingRouteService";
export { default as WoundPatientService } from "./WoundPatientService";
export { default as WoundPatientRouteService } from "./WoundPatientRouteService";
